import React from "react";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";

const StyledTextArea = styled("textarea")(({ theme }) => {
  return{
  borderColor: theme.palette.mode==='light'?"rgba(0, 0, 0, 0.23)": "rgba(255, 255, 255, 0.23)",
  fontFamily:"DM Sans,sans-serif",
  borderRadius: "8px",
  outline: "none",
  padding: "8px 12px",
  fontSize: "13px",
  display: "block",
  width: "100%",
  maxHeight: "120px",
  resize: "vertical",
  backgroundColor:theme.palette.background.paper,
  color: theme.palette.text.primary,
  "&:hover": {
    // borderColor: "#A77BCA",
    borderColor: theme.palette.text.primary,
  },
  "&:focus": {
    // boxShadow: "0 0 0 2.5px #E5D7EF",
    borderColor:theme.palette.mode==='light' ? theme.palette.primary.main : theme.palette.common.white,
    borderWidth: "1.5px",
  },
  "&:disabled": {
    backgroundColor: "#F5F5F5",
    borderColor: "#D8D8D8",
  },   
  "&.error": {
    borderColor: theme.palette.error.main,
  },
  '&::placeholder': {
    color: '#7F7F7F',
    opacity: 0.75,

  },
}
});

const StyledHelperText = styled(Typography)(({ theme }) => ({
  fontSize: "11px",
  marginLeft: "12px",
  marginTop: "3px",
  fontFamily:"DM Sans,sans-serif",
  lineHeight:1.66,
  textAlign: "left",
  color: theme.palette.text.secondary,
  "&.error": {
    color: theme.palette.error.main,
  },
}));

const CustomTextArea = ({
  label,
  id,
  disabled = false,
  value,
  onChange,
  isMandatoryField = false,
  maxLength = 255,
  placeholder = "Please Enter",
  helperText = "",
  error = false,
}) => {
  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <>
      <Typography
        variant="labelSm"
        color="text.primary"
        component="label"
        htmlFor={id}
        fontSize={"12px"}
        fontFamily={"DM Sans,sans-serif"}
      >
        {label}
        {isMandatoryField && (
          <Typography component="span" color="error">
            *
          </Typography>
        )}
      </Typography>
      <StyledTextArea
        id={id}
        disabled={disabled}
        value={value}
        onChange={handleInputChange}
        placeholder={disabled?'':placeholder}
        maxLength={maxLength}
        className={error ? "error" : ""}
      />
      <StyledHelperText fontSize={"11px"} className={error ? "error" : ""}>
        {helperText}
      </StyledHelperText>
    </>
  );
};

export default CustomTextArea;
